import productActionType from "./products";

const types = {
  ...productActionType,
};

export default types;
